import { captureErrorAsync } from '../../utils/capture-error-async';
import { analyticsFullyLoaded } from '../../utils/ready';
import { logger } from './logger';

interface AdAttributionEntry {
  ts: string;
  value: string;
}

interface AdAttribution {
  gclid?: AdAttributionEntry[];
  fbclid?: AdAttributionEntry[];
}

interface Traits {
  adAttribution?: AdAttribution;
  [key: string]: unknown;
}

function pushAttributionParam(
  key: keyof AdAttribution,
  state: AdAttribution,
  urlParams: URLSearchParams
) {
  try {
    const value = urlParams.get(key);

    if (value == null) {
      return state;
    }

    const entries = state[key] || [];
    entries.push({ ts: new Date().toISOString(), value });
    state[key] = entries;

    return state;
  } catch (e) {
    captureErrorAsync(e as Error);
    return state;
  }
}

export async function persistAttributionParams(): Promise<void> {
  if (typeof URLSearchParams === 'undefined') {
    return;
  }

  const analytics = await analyticsFullyLoaded();
  // @ts-ignore
  const traits: Traits = analytics.user().traits();
  const urlParams = new URLSearchParams(window.location.search);
  const adAttribution: AdAttribution = traits.adAttribution || {};

  pushAttributionParam('gclid', adAttribution, urlParams);
  pushAttributionParam('fbclid', adAttribution, urlParams);

  analytics.identify({ adAttribution });
}
